import { worstResourceState, type ResourceInspection } from "@/features/adapters/model";

interface StepReference {
  key: string;
  label: string;
  /** Label for the combined action when a step owns several resources. */
  actionLabel?: string;
}

/** Folds the applicable resources owned by a workflow step into one inspection. */
export const getAdapterStepResource = (
  inspections: ResourceInspection[],
  step: StepReference | undefined,
): ResourceInspection | undefined => {
  if (!step) return undefined;
  const resources = inspections.filter((inspection) => inspection.stepId === step.key && inspection.applicable);
  if (resources.length === 0) return undefined;
  if (resources.length === 1) return resources[0];
  const complete = resources.every((resource) => resource.complete);
  const applyLabel = resources.find((resource) => resource.action?.kind === "apply")?.action?.label;
  return {
    ...resources[0],
    key: step.key,
    stepId: step.key,
    label: step.label,
    complete,
    state: worstResourceState(resources.map((resource) => resource.state)),
    message: complete ? "All resources for this step are ready." : "This step needs configuration.",
    action: complete || !applyLabel ? undefined : { kind: "apply", label: step.actionLabel ?? applyLabel, stepId: step.key },
  };
};
